import React, { useEffect, useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import SaveButton from "../../CommonComponents/SaveButton/SaveButton";

function PaymentsInfo({ getRedemptionsPending, paymentInfo, apiRunning }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );
  const totalAmount = paymentInfo.totalAmount;
  const usersAffected = paymentInfo.usersAffected;

  const [isApiRunning, setIsApiRunning] = useState(apiRunning);
  const [isSettling, setIsSettling] = useState(false);
  
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [remainingTxns, setRemainingTxns] = useState("Fetching...");
  const [totalTxns, setTotalTxns] = useState("Fetching...");

  useEffect(() => {
    const ws = new WebSocket(
      `wss://ktb6gsx61g.execute-api.us-east-2.amazonaws.com/prod?token=${token?.IdToken}`
    );

    ws.onopen = () => {
      console.log("WebSocket connected");
    };

    ws.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data?.event_type === "low_fbo_tx_count") {
        if (
          data?.data?.current_processing_txn === data?.data?.total_txn
        ) {
          setIsSettling(false);
          setSuccessMessage("Payout completed.");
          getRedemptionsPending();
        }

        setRemainingTxns(data?.data?.remaining_txn);
        setTotalTxns(data?.data?.total_txn);
      }
    };

    ws.onerror = (error) => {
      console.log("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };

    return () => {
      ws.close();
    };
  }, [token?.IdToken]);

  const payoutUsers = async () => {
    setErrorMessage("");

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.PENDING_REDEMPTIONS_TRIGGER
      );

      setSuccessMessage("Payout initiated. This will update automatically.");
      setIsSettling(true);
    } catch (error) {
      console.log("error in payout", error);
      setErrorMessage("Payout failed.");
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className="payments-info">
      {isApiRunning ? (
        <RebetLoader height={"100px"} width={"100px"} />
      ) : (
        <>
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          {!isSettling && (
            <>
              <div className="stat">
                <div className="stat-title">Users affected</div>
                <div className="stat-value">
                  {usersAffected} {usersAffected > 1 ? "users" : "user"}
                </div>
              </div>
              <div className="stat">
                <div className="stat-title">Total amount</div>
                <div className="stat-value">$ {totalAmount}</div>
              </div>
            </>
          )}
          {isSettling && (
            <>
              <div className="stat">
                <div className="stat-title">Total transactions</div>
                <div className="stat-value">{totalTxns}</div>
              </div>
              <div className="stat">
                <div className="stat-title">Remaining transactions</div>
                <div className="stat-value">{remainingTxns}</div>
              </div>
            </>
          )}
          <SaveButton
            isApiRunning={isSettling}
            callbackFunction={payoutUsers}
            buttonText="Payout users"
            disabled={isSettling}
          />
        </>
      )}
    </div>
  );
}

export default PaymentsInfo;
